/**
 * Centralized React Query Key Management
 *
 * This file provides a centralized factory for all React Query keys used in the application.
 * This ensures consistency and prevents typos in query keys across the codebase.
 */

// Auth query keys
export const authKeys = {
  all: ['auth'] as const,
  profile: () => ['auth', 'profile'] as const,
  user: () => ['auth', 'user'] as const,
}
